<template>
    <form @submit.prevent="apply">
        <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{translate('approvalAuthorityEditor.approvalAuthority')}}</h5>
                    <a href="#void" class="close" data-dismiss="modal" :aria-label="translate('close')" @click="close()">
                        <span aria-hidden="true">&times;</span>
                    </a>
                </div>
                <tab :tabs="tabs" :bullets="false" v-model="approvalAuthority.Kind" @change="changeTab()"/>
                <div class="modal-body" style="height: 470px ;">
                    <div style="padding:30px 10px 15px 10px; height:350px;">
                        <div v-if="approvalAuthority.Kind == 'ApprovalAuthorityUser'">                            
                            
                            <div>{{translate('approvalAuthorityEditorUser.selectUser')}}:</div>
                            <select-user :user-list="userList" v-on:change="userChange()" v-model="approvalAuthority.UserId" required></select-user>
                            
                            <div class="form-check mt-1">
                                <input 
                                    class="form-check-input" 
                                    type="checkbox" 
                                    value="true" 
                                    id="approvalAuthorityEditor.ListAllUsers" 
                                    @change="changeState('SET_LIST_ALL_USERS',$event.target.checked)"
                                    :checked="IsListAllUsers" 
                                    >
                                <label class="form-check-label" for="approvalAuthorityEditor.ListAllUsers">
                                    {{translate('approvalAuthorityEditor.listAllUsers')}}
                                </label>
                            </div>


                            <div v-if="approvalAuthority.User" style="padding-top:26px;">
                                <div class="float-left">
                                    <img v-auth-image="approvalAuthority.User.ProfilePictureUrl" @onerror="this.src='/img/no-profile.jpg'" style="height:100px" class="profile-picture-square"/>
                                </div>
                                <div class="float-left" style="padding-left:16px;">
                                    <h5 style="margin-bottom:4px;">{{approvalAuthority.User.FirstName}} {{approvalAuthority.User.LastName}}</h5>
                                    <div v-if="approvalAuthority.User.Title && approvalAuthority.User.Title.Name">{{approvalAuthority.User.Title.Name}}</div>
                                    <div><a :href="'mailto:' + approvalAuthority.User.Email">{{approvalAuthority.User.Email}}</a></div>
                                    <div v-if="approvalAuthority.User.Departments && approvalAuthority.User.Departments.length > 0" :title="translate('approvalAuthorityEditor.departments')">
                                        <span class="text-muted">Dept.:</span> <span v-for="(d, index) in approvalAuthority.User.Departments" :key="d.Id"><span v-if="index > 0">, </span>{{d.Name}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="approvalAuthority.Kind == 'ApprovalAuthorityExternal'">
                            <div v-if="hasModule('ExternalSigner')">
                                <div class="form-group row">
                                    <label for="ExternalSignersId" class="col-md-4 col-form-label">{{translate('approvalAuthorityEditor.externalUsers')}}</label>
                                    <div class="col-md-8">
                                        <div class="input-group">
                                            <select-input
                                            ref="ExternalSignersId"
                                            name="ExternalSignersId"
                                            :value="externalSignerMail"
                                            :autocomplete="true"
                                            :placeholder="translate('search')"
                                            :items="externalSigners" 
                                            :filter-function="
                                                (item, search) => new RegExp(search, 'i').test(item.Name)
                                            "
                                            @change="externalSignerChanged"
                                            id="ExternalSignersId"
                                            >
                                            
                                            <span v-if="externalSignerMail == ''"><i>{{translate('approvalAuthorityEditor.canChooseExternalSigner')}}</i></span>
                                            <span v-else-if="externalSignerMail">
                                                {{ externalSignerMail }}
                                            </span>
                                            <template v-slot:item="{ item }">
                                                <div style="padding: 2px 0">
                                                {{ item.Email }}
                                                </div>
                                            </template>
                                            </select-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="External.FirstName" class="col-md-4 col-form-label">{{translate('approvalAuthorityEditor.name')}}</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" id="External.FirstName" name="FirstName" @input="checkInput('FirstName',$event)" @change="approvalAuthority.FullName = approvalAuthority.FirstName + ' ' + approvalAuthority.LastName" v-model="approvalAuthority.FirstName" required/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="External.LastName" class="col-md-4 col-form-label">{{translate('approvalAuthorityEditor.surname')}}</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" id="External.LastName" @input="checkInput('LastName',$event)" name="LastName" @change="approvalAuthority.FullName = approvalAuthority.FirstName + ' ' + approvalAuthority.LastName" v-model="approvalAuthority.LastName" required/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="External.Email" class="col-md-4 col-form-label">{{translate('approvalAuthorityEditorUser.email')}}</label>
                                    <div class="col-md-8">
                                        <input type="email" class="form-control" id="External.Email" name="Email" @input="checkInput('Email',$event)" v-model="approvalAuthority.Email" required/>
                                    </div>
                                </div>
                                <div class="form-group row"  v-if="IsIdentityNumberRequiredForExternalSigner">
                                    <label for="External.IdentityNumber" class="col-md-4 col-form-label">{{translate('approvalAuthorityEditor.identityNumber')}}</label>
                                    <div class="col-md-8">
                                        <input type="tel" class="form-control" id="External.IdentityNumber" name="IdentityNumber" v-model="approvalAuthority.IdentityNumber" :required="IsIdentityNumberRequiredForExternalSigner"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="External.Phone" class="col-md-4 col-form-label">{{translate('approvalAuthorityEditor.phone')}}</label>
                                    <div class="col-md-8">
                                        <div class="input-group">
                                            <!-- <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon1">+90</span>
                                            </div>
                                            <input type="tel" class="form-control" id="External.Phone" maxlength="10" placeholder="5XXXXXXXXX" name="Phone" v-model="approvalAuthority.Mobile" required/> -->
                                            <VuePhoneNumberInput id="External.Phone"
                                                    v-model="mobileNumber" :dark="dark" :disabled="disabled"
                                                    :preferred-countries="countriesList" :loader="hasLoaderActive" :default-country-code="defaultCountry" noCountrySelector
                                                    clearable :error="hasErrorActive" class="phoneColumn"  :translations="trPhoneParams" @update="onUpdate"/>
                                        </div>
                                    </div>
                                </div>
                            
                                <!-- <div class="form-group row">
                                <label  class="col-md-4 col-form-label">Mobil İmza Operatörü</label>
                                <div class="col-md-8">
                                    <select v-model="approvalAuthority.MobileSignOperator" class="form-control">
                                        <option value="">Mobil imzası yok</option>
                                        <option value="TURKCELL">Turkcell</option>
                                        <option value="AVEA">Türk Telekom</option>
                                        <option value="VODAFONE">Vodafone</option>
                                    </select>
                                </div>
                            </div> -->
                            <div class="form-group row">
                                <label for="External.Direct"  class="col-md-4 col-form-label">{{translate('approvalAuthorityEditor.canBeDirected')}}</label>
                                <div class="col-md-8">
                                    <input type="checkbox" :checked="false" class="form-control" id="External.Direct" style="width: 30px; height: 30px; position: fixed;" v-model="approvalAuthority.IsDirect"/>
                                </div>
                            </div>
                        </div>
                            <div v-else>
                                <div class="alert alert-warning">
                                    <h5>{{translate('warnings.externalSignerModuleNotActive')}}</h5>
                                    <p>
                                        {{translate('warnings.externalSignerModuleNotActiveText')}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div v-if="approvalAuthority.Kind == 'ApprovalAuthorityTitle'">
                            {{translate('approvalAuthorityEditor.titleEditForm')}}
                        </div>
                    </div>
                </div>
                <div class="modal-footer footer-button-container-1">
                    <div>
                        <button type="button" class="btn btn-outline-secondary" @click="close()" data-dismiss="modal" style="margin: 0px 10px;">{{translate('cancel')}}</button>
                        <button  v-if="approvalAuthority.Kind == 'ApprovalAuthorityExternal'" type="button" class="btn btn-info float-left" @click="save" data-dismiss="modal">{{translate('save')}}</button>
                    </div>
                    <div>
                        <button type="submit" class="btn btn-primary" :disabled="approvalAuthority.Kind == 'ApprovalAuthorityExternal' && !hasModule('ExternalSigner')">{{translate('okay')}}</button>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
//import userEditor from './ApprovalAuthorityEditor_User.vue';
import selectUser from './SelectUser.vue'
import tab from '../components/Tab.vue'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import selectInput from "../components/SelectInput.vue";
import axios from 'axios';

export default {
    components: {
        //userEditor
        selectUser,
        tab,
        VuePhoneNumberInput,
        selectInput
    },
    created(){
        this.approvalAuthority = Object.assign({}, this.value); //JSON.parse(JSON.stringify(this.value));
        this.externalSignerMail = "";
        this.mobileNumber = this.approvalAuthority.Mobile;
        this.getExternalSigners().then(x => {
            this.externalSigners = x.Result;
        }).catch(x => {
                console.warn("external signer listesi yüklenemedi:", x);
            });
    },
    props: {
        value : Object,
        userList : {
            type:Array,
            required: true
        }
    },
    data(){
        return {
            approvalAuthority: {},
            tabs: [
                { key: "ApprovalAuthorityUser", text: this.translate('tabs.approvalAuthorityTabs.approvalAuthorityUser') },
                { key: "ApprovalAuthorityExternal", text: this.translate('tabs.approvalAuthorityTabs.approvalAuthorityExternal') }
            ],
            defaultCountry: "TR",
            countriesList: ["TR"],
            dark: false,
            disabled: false,
            hasLoaderActive: false,
            hasErrorActive: false,
            mobileNumber: null,
            trPhoneParams : { countrySelectorLabel: 'Ülke Kodu', countrySelectorError: 'Ülke Seç', phoneNumberLabel: this.translate('phoneNumberLabel'), example: 'Örnek:' },
            externalSigners: [],
            data:{},
            externalSignerMail: null,
        }
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.approvalAuthority, value, editedText)
            } else {
                this.$set(this.approvalAuthority, value, event.target.value)
            }
        },
        userChange(){
            var user = {};
            Object.assign(user, this.userList.filter(x => x.Id == this.approvalAuthority.UserId)[0]);
            this.approvalAuthority.User = user;

            console.log('user:', user);

            this.approvalAuthority.FullName = user.FirstName + ' ' + user.LastName;
        },
        externalSignerChanged(value) {
            console.log("changed")
            this.externalSignerMail = value.Email
            console.log(this.approvalAuthority)
            this.approvalAuthority.FirstName = value.Name
            this.approvalAuthority.LastName = value.Surname
            this.approvalAuthority.Email = value.Email
            if(this.IsIdentityNumberRequiredForExternalSigner){
                this.approvalAuthority.IdentityNumber = value?.IdentityNumber;
            }
            this.approvalAuthority.FullName = value.Name + ' ' + value.Surname
            this.mobileNumber = value.Phone
            this.approvalAuthority.Mobile = value.Phone

        },
        close(){
            this.$emit('cancel');
        },
        save(){
            var form = {}
            form.Name = this.approvalAuthority.FirstName;
            form.Surname = this.approvalAuthority.LastName;
            form.Email = this.approvalAuthority.Email;
            form.Phone = this.approvalAuthority.Mobile;
            form.IdentityNumber = this.approvalAuthority?.IdentityNumber;
            console.log("this data will be posted: ", {form: form})
            axios.post("/externalsigner/QuickPost", form).then(() => {
                   alert(this.translate('messages.userSaveSuccess'))
                })
                .catch(()=> {
                    alert(this.translate('errors.userSaveFail'))
                })
        },
        apply(e){
            
            if(this.hasErrorActive)
            {
                
                
                e.target.elements["3"].setCustomValidity(this.translate('errors.enterValidPhone'));
                e.target.elements["3"].reportValidity();
                return false;
            }
            else {
               
                e.target.elements["3"].setCustomValidity("");

            }
                
            this.$emit('input', this.approvalAuthority);
            this.$emit('apply', this.approvalAuthority);
        },
        changeTab(){
            this.approvalAuthority.FirstName = "";
            this.approvalAuthority.FullName = "";
            this.approvalAuthority.LastName = "";
            this.approvalAuthority.Email = "";
        },
        onUpdate(payload) {
            var input = document.getElementById('External.Phone').lastChild.firstChild.firstChild;
            
            this.hasErrorActive = !payload.isValid;
            if(!this.hasErrorActive){
                input.setCustomValidity("");
            }
            
            this.approvalAuthority.Mobile = payload.nationalNumber;
            // console.log(this.approvalAuthority)
        },
    },
    computed:{
        IsIdentityNumberRequiredForExternalSigner(){
            // Dış kullanıcılar için T.C. kimlik numarası zorunlu mu?
            return this.$root.$data.login.Account.Params.IsIdentityNumberRequiredForExternalSigner;
        },
        IsListAllUsers(){
            return this.$store.state.approvalUserEditor.ListAllusers;
        },
    }
}
</script>

<style scoped>
/* .bg {
    background-color: rgba(7, 3, 24, 0.452);
    position: fixed;
    left:0;
    right:0;
    top:0;
    bottom:0
} */
.phoneColumn{
    width: 100%;
}

.footer-button-container-1{
    display: flex;
    align-items: center;
    justify-content: space-between !important;
}
</style>